import styled from 'styled-components'
import { Spin } from 'antd'

export const AntSpin = styled(Spin)`
  color: ${props => props.theme.PRIMARY_COLOR};

  .ant-spin-dot-item {
    background-color: ${props => props.theme.PRIMARY_COLOR};
  }
`